import type {PropsWithChildren} from 'react'
import React from 'react'
import DashboardLayout from '~/layouts/DashboardLayout'
import type {IAdminRouteComponentProps} from '~/routing/Route/Admin'
import {isolateAdminRouteComponentProps} from '~/routing/Route/Admin'

interface IProps extends PropsWithChildren<IAdminRouteComponentProps> {}

export default class AdminLayout extends React.Component<IProps> {
  render() {
    return (
      <DashboardLayout {...isolateAdminRouteComponentProps(this.props)}>
        {this.props.children}
      </DashboardLayout>
    )
  }
}
